import React from "react";

const FooterBottom = () => {
  return (
    <div className="w-full py-10">
      <p className="text-center text-gray-500 text-base">
        <span className="text-xl text-designColor">©</span> 2024. All rights
        reserved by{" "}
        <span className="font-signature text-xl text-designColor">
          Laxmi Sainath Islavath
        </span>
      </p>
    </div>
  );
};

export default FooterBottom;
